import moment from 'moment';

export const formatDate = (date : any, dateOnly: any) => {
    if (!date) {
        return null;
    }

    if (dateOnly) {
        return moment(date).format("MM-DD-YYYY");
    }

    let dt = moment(date);

    return (dt.hours() === 0 && dt.minutes() === 0 && dt.seconds() === 0 ? dt.format('MM/DD/YYYY') : dt.format('hh:mm:ss A MM-DD-YYYY'));
}